import { render, staticRenderFns } from "./SparkleIcon.vue?vue&type=template&id=13dd9695&scoped=true"
import script from "./SparkleIcon.vue?vue&type=script&lang=js"
export * from "./SparkleIcon.vue?vue&type=script&lang=js"
import style0 from "./SparkleIcon.vue?vue&type=style&index=0&id=13dd9695&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd9695",
  null
  
)

export default component.exports